<template>
	<div class="Videopublicity">
		<div class="Videopublicity-top">
			<div class="Videopublicity-top-img">
				<img
					:src="require('@/assets/images/Companycultrue-top.png')"
					class="image-width"
					alt=""
				/>
			</div>
		</div>
		<div class="Videopublicity-mid-out">
			<div class="Videopublicity-mid">
				<img
					:src="require('@/assets/images/Videopublicity-mid.png')"
					class="image-width"
					alt=""
				/>
			</div>
			<div class="Videopublicity-mid-text">{{ $t('视频宣传') }}</div>
		</div>
		<div class="Videopublicity-box">
			<div
				class="Videopublicity-box-item"
				v-for="(item, index) in videolist"
				:key="index"
			>
				<div class="box-item-img" @click="playVideo(item)">
					<img
						class="video-poster"
						:src="lang === 'en' ? item.iconEn : item.iconSJ"
						alt="视频封面"
					/>
					<img class="play-btn" src="@/assets/images/Videopublicity-play.png" />
				</div>
				<div class="box-item-text">
					{{ getLangText(item, 'name') }}
				</div>
			</div>
		</div>

		<van-popup v-model="showVideo">
			<VideoBox
				class="video-box"
				:style="{ width: width + 'px', height: height + 'px' }"
				:videoSrc="currentVideo"
				:poster="currentPoster"
				ref="videoPlayer"
			/>
		</van-popup>
	</div>
</template>

<script>
import { getVideoList } from '@/api';
import VideoBox from '@/components/VideoBox/TcPlayer.vue';
export default {
	components: {
		VideoBox
	},
	data() {
		return {
			videolist: [],
			showVideo: false,
			currentVideo: '',
			currentPoster: '',
			width: 375,
			height: 220
		};
	},
	created() {
		this.frontListFZ();
	},
	mounted() {
		// 根据屏幕宽度设置视频宽度
		this.width = window.innerWidth;
		// 根据屏幕高度设置视频高度
		this.height = (window.innerWidth * 9) / 16;
	},
	methods: {
		//业务图片接口
		frontListFZ() {
			let params = {
				type: 3,
				language: Number(this.lang === 'en')
			};
			getVideoList(params).then(res => {
				this.videolist = res.list.map(it => ({
					...it,
					isPlaying: false
				}));
			});
		},
		//点击播放视频
		playVideo(item) {
			this.showVideo = true;
			this.currentVideo = item.url;
			this.currentPoster = item.iconSJ;
		}
	}
};
</script>

<style lang="scss">
@use './Videopublicity.scss';
</style>
